import React from 'react';
import { AbbVieBranchingScreen } from './components/AbbVieBranchingScreen';
import { AbbVieEvidenceScreen } from './components/AbbVieEvidenceScreen';
import { ClosingScreen } from './components/ClosingScreen';
import { CollaborationModelScreen } from './components/CollaborationModelScreen';
import { CommitmentCurveScreen } from './components/CommitmentCurveScreen';
import { CurrentStateScreen } from './components/CurrentStateScreen';
import { DeploymentMechanicsScreen } from './components/DeploymentMechanicsScreen';
import { HighValueActionsScreen } from './components/HighValueActionsScreen';
import { HookScreen } from './components/HookScreen';
import { IntroScreen } from './components/IntroScreen';
import { RegionalCustomizationScreen } from './components/RegionalCustomizationScreen';
import { Logo } from './components/snakker/Logo';
import { SnackificationModelScreen } from './components/SnackificationModelScreen';
import { StorytellingScreen } from './components/StorytellingScreen';
export function App() {
  return <div className="w-full overflow-x-hidden bg-white text-slate-900 selection:bg-primary selection:text-white" data-id="element-0" data-mp="3ij668fcdfvai">
      <div className="fixed bottom-4 right-4 z-50 rounded-lg border border-slate-200 bg-white/95 p-2 shadow-sm" aria-label="Designed with SNAKKER" data-id="element-1" data-mp="3mjq1fdddwou0">
        <Logo width={24} height={24} alt="SNAKKER" data-id="element-2" data-mp="6hqtghuuhen" />
      </div>
      <main data-id="element-3" data-mp="82jt1oitsae">
        <IntroScreen data-id="element-4" data-mp="2zl39tfhhuw2o" />
        <CurrentStateScreen data-id="element-5" data-mp="2zlldgx6hkckm" />
        <HookScreen data-id="element-6" data-mp="2zmenq84nlk7i" />
        <SnackificationModelScreen data-id="element-7" data-mp="2zmwlj96ys6hj" />
        <CommitmentCurveScreen data-id="element-8" data-mp="33mf0loc3tncg" />
        <DeploymentMechanicsScreen data-id="element-9" data-mp="33nges1of2pye" />
        <AbbVieBranchingScreen data-id="element-10" data-mp="33orla998ybt7" />
        <HighValueActionsScreen data-id="element-11" data-mp="38l8iru2c62iy" />
        <StorytellingScreen data-id="element-12" data-mp="38l06a3a4kz8a" />
        <AbbVieEvidenceScreen data-id="element-13" data-mp="38nulngea7tuu" />
        <RegionalCustomizationScreen data-id="element-14" data-mp="3dle1gkqmoeow" />
        <CollaborationModelScreen data-id="element-15" data-mp="3dmfprqwnmxok" />
        <ClosingScreen data-id="element-16" data-mp="3dii6n5a2u64o" />
      </main>
    </div>;
}